.dda-footer {
    box-shadow: 0 -2px 13px 0 rgba(0, 0, 0, 0.12);
    background-color: var(--dda-surface-100);
    color: var(--dda-surface-0);
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 5;
    padding: 0 20px;
    transform: translateY(0);
    /* transition: transform 0.3s ease-in-out; */
}
.dda-footer.hidden {
  transform: translateY(100%);
}
.footer-content {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.dda-footer-item {
    display: flex;
    align-items: center;
    position: relative;
}
.dda-footer-item ul {
    display: inline-flex;
    align-items: center;
}

.dda-footer-item ul li {
    padding: 0 10px;
    border-inline-start: solid 1px #E0E3E2;
}

.dda-footer-item ul li:first-child {
    border: 0px;
}

.foot-icon-btn a{
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: var(--font-caption);
    font-weight: var(--font-weight-regular);
    color: var(--dda-surface-0);
}
.foot-icon-btn a:visited{
    color: var(--dda-on-primary-variant-40);
}
.foot-icon-btn a i,
.dda-footer-right button i{
    color: var(--dda-on-surface-variant-30);
}

.foot-icon-btn a img {
    height: 32px;
}
.dda-footer-item ul li.foot-menu{
    padding: 0 5px;
}
.foot-menu a {
    color: var(--dda-on-surface-0);
}

.foot-menu a i,
.foot-menu a svg {
    font-size: 20px;
    color: var(--dda-on-surface-variant-30);
    fill: var(--dda-on-surface-variant-30);
}

.foot-menu a img {
    height: 40px;
}

.foot-logo a {
    background-color: var(--dda-neutral-100);
    height: 40px;
    display: flex;
    align-items: center;
}

.foot-logo a img {
    height: 35px;
}
.dda-footer-right button.show-right-icon{
    display: none;
}
/* @media only screen and (orientation: landscape) and (max-width: 768px) {
    .footer-content{
        height: 44px;
    }
    .dda-footer-item .foot-icon-btn a{
        width: 35px;
        height: 35px;
    }
} */
.dda-footer .dubaiae-text-icon{
    height: 18px;
}
.dda-footer .dubaiae-small-icon{
    height: 18px;
    display: none;
}

@media (max-width: 1024px) {
    .dda-footer {
        background: transparent;
        box-shadow: none;
        padding-left: 32px;
        padding-right: 32px;
        padding-bottom: 32px;
    }
    .footer-content{
        height: auto;
    }
    .foot-menu,
    .foot-icon-btn a span {
        display: none;
    }
    .dda-footer-item ul{
        gap: 16px
    }
    .dda-footer-item ul li {
        padding: 0px;
        border: 0px !important;
    }

    .foot-icon-btn a,
    .dda-footer-right button {
        width: 48px;
        height: 48px;
        background: #ffffff;
        border-radius: 50px;
        border: 0px;
        box-shadow: 0 6px 20px rgba(0, 0, 0, .2);
    }
    
    .dda-footer-right button.show-right-icon{
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .foot-icon-btn a img {
        height: 24px;
    }

    .foot-icon-btn a i{
        font-size: 23px;
    }
    .dda-footer-right button i{
        font-size: 34px;
    }
    .dda-footer-right .foot-right_links {
        position: absolute;
        bottom: 59px;
        inset-inline-end: 0px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        height: 0;
        overflow: hidden;
    }
    .dda-footer-right .foot-right_links.show-dda-icon{
        height: auto;
        overflow: visible;
    }
    .foot-right_links li.foot-icon-btn {
        list-style: none;
        opacity: 0;
        transform: translateY(20px);
        /* transition: opacity 0.4s ease, transform 0.4s ease; */
    }
    @media (prefers-reduced-motion: no-preference) {
        .foot-right_links li.foot-icon-btn,
        .dda-footer-right .foot-right_links {
            transition: opacity 0.4s ease, transform 0.4s ease;
        }
    }
    .foot-right_links.show-dda-icon li.foot-icon-btn {
        opacity: 1;
        transform: translateY(0);
    }
    .dda-footer .dubaiae-text-icon{
        display: none;
    }
    .dda-footer .dubaiae-small-icon{
        height: 24px;
        display: block;
    }

    
}

@media (max-width: 640px) {
    .dda-footer {
        padding-left: 16px;
        padding-right: 16px;
        padding-bottom: 16px;
    }
}

@media (max-width: 1200px) {
    
}

@media (max-width: 1400px) {
    .dda-footer-middle {
        display: none;
    }
    
}

@media (prefers-reduced-motion: no-preference) {
    .dda-footer {
        transition: transform 0.3s ease-in-out;
    }
}